// Ajustes > Agenda e mapas (0.67, texto 05 D3): Agenda do Google e Rotas e mapas (vieram da antiga "Configuração geral").
import { Platform } from 'react-native';
import { AgendaGoogle } from '../../components/AgendaGoogle';
import { useDoc } from '../../store/store';
import { setAppMapa, type AppMapa } from '../../lib/mapa';
import { t } from '../../lib/i18n';
import { Card } from './comum';
import { Bloco, LinhaOpcoes } from '../../components/ajustes/Linhas';
import { Section } from '../../components/ui';

export default function AgendaMapas({ cor }: { cor: string }) {
  const aj = useDoc('ajustes');
  const apps: [AppMapa, string][] = [['perguntar', t('Perguntar sempre')], ['google', 'Google Maps'], ['waze', 'Waze'], ...(Platform.OS === 'ios' ? [['apple', t('Mapas (Apple)')] as [AppMapa, string]] : [])];
  return (<>
    <Section t={t('Agenda do Google')} />
    <Card><AgendaGoogle cor={cor} /></Card>
    <Bloco titulo={t('Rotas e mapas')}>
      <LinhaOpcoes icone="🗺️" titulo={t('App das rotas')} valor={aj.mapa ?? 'perguntar'} opcoes={apps} onEscolher={setAppMapa}
        dica={t('App usado no botão "Rota" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).')} />
    </Bloco>
  </>);
}
